import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import styled from 'styled-components';
import { ContentPanel } from './components/ContentPanel'
import { ConversationContextProvider } from './contexts/ConversationContext';
import { FeedbackRequestScreen } from './components/FeedbackRequestScreen';

const MainPanelDiv = styled.div`
    margin: -8px;
    height: 100dvh;
    background-color: #CCE6D6;
    font-family: Helvetica, Arial, sans-serif;
    font-weight: 200;
    font-size: 16px; 
    line-height: 19.2px;
    color: #000;

    a {color: #008334;}
    p {margin: 0 0 14px 0;}
`

const queryClient = new QueryClient()

export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ConversationContextProvider>
        <MainPanelDiv>
          <ContentPanel />
          <FeedbackRequestScreen />
        </MainPanelDiv>
      </ConversationContextProvider>
    </QueryClientProvider>
  );
}
